import { useState } from 'react';
import { ActionBar, EditPrintTemplateDialog, FormDialog, SearchDialog } from './components';
import { HoaDonDieuChinhThongTinInput } from '@/types/schemas';
import { useHoaDonDieuChinhThongTin, useRows } from '@/hooks';
import { ErpDataTableV2 } from '@/components/custom/erp';
import { getDataTableColumns } from './cols-definition';

export default function DieuChinhThongTinHoaDonDaXacThuc() {
  const [showTables, setShowTables] = useState(false);
  const [showSearchDialog, setShowSearchDialog] = useState(true);
  const [showEditPrintTemplateDialog, setShowEditPrintTemplateDialog] = useState(false);
  const [showAddDialog, setShowAddDialog] = useState(false);

  const { selectedRowIndex, handleRowClick } = useRows();
  const { addHoaDonDieuChinhThongTin } = useHoaDonDieuChinhThongTin();

  const handleSearch = () => {
    setShowSearchDialog(true);
  };

  const handleSearchSubmit = (filters: BanHangPayload) => {
    setShowSearchDialog(false);
    setShowTables(true);
  };

  const handleAddSubmit = (data: HoaDonDieuChinhThongTinInput) => {
    addHoaDonDieuChinhThongTin(data);
    setShowAddDialog(false);
  };

  const handleRefresh = () => {};

  const handleFixedColumns = () => {};

  const handleExportData = () => {};

  const handleEditPrintTemplate = () => {
    setShowEditPrintTemplateDialog(true);
  };

  const tables = [
    {
      name: ``,
      rows: [],
      columns: getDataTableColumns()
    }
  ];

  return (
    <div className='flex h-full min-h-screen w-screen flex-col lg:overflow-hidden'>
      {showSearchDialog && (
        <SearchDialog
          open={showSearchDialog}
          onClose={() => setShowSearchDialog(false)}
          onSearch={handleSearchSubmit}
        />
      )}

      {showEditPrintTemplateDialog && (
        <EditPrintTemplateDialog
          open={showEditPrintTemplateDialog}
          onClose={() => setShowEditPrintTemplateDialog(false)}
        />
      )}

      {showAddDialog && (
        <FormDialog onSubmit={handleAddSubmit} open={showAddDialog} onClose={() => setShowAddDialog(false)} />
      )}

      {showTables && (
        <div className='w-full'>
          <ActionBar
            onSearch={handleSearch}
            onRefresh={handleRefresh}
            onExportData={handleExportData}
            onFixedColumns={handleFixedColumns}
            onAddButtonCLick={() => setShowAddDialog(true)}
          />
          <ErpDataTableV2 tables={tables} selectedRowId={selectedRowIndex || undefined} onRowClick={handleRowClick} />
        </div>
      )}
    </div>
  );
}
